/** Pieces shared by the Latency tab's reply and message-delivery sections. */

/** Seconds, to one decimal under a minute and whole seconds above it. Receipt
 *  lags can run to hours, so past an hour it switches to h/m. */
export function secs(v: number | null | undefined): string {
  if (v === null || v === undefined) return "—";
  if (v < 60) return `${v.toFixed(1)}s`;
  if (v < 3600) return `${Math.round(v)}s`;
  const h = Math.floor(v / 3600);
  const m = Math.round((v % 3600) / 60);
  return m ? `${h}h ${m}m` : `${h}h`;
}

export function Tile({
  label,
  value,
  sub,
  tone,
}: {
  label: string;
  value: string;
  sub?: string;
  tone?: "bad";
}) {
  return (
    <div className={tone === "bad" ? "tile tile-bad" : "tile"}>
      <div className="tile-label">{label}</div>
      <div className="tile-value">{value}</div>
      {sub && <div className="tile-sub">{sub}</div>}
    </div>
  );
}
